import { z } from "zod";
import {
	passwordBaseSchema,
	passwordsMatch,
	passwordsMatchError,
} from "@/core/schemas/password.schema";

export const pwResetRequestSchema = z.object({
	email: z.string().min(1, "email.required").pipe(z.email("email.invalid")),
});

// Reuse the shared password rules (complexity + confirmation match) from
// password.schema so reset stays in lockstep with first-time password set.
// We only add the reset-specific `code` field on top of the base shape.
export const pwResetConfirmSchema = passwordBaseSchema
	.extend({
		code: z
			.string()
			.min(1, "confirmation.required")
			.max(8, "confirmation.invalid"),
	})
	.refine(passwordsMatch, passwordsMatchError);

export type PwResetRequestData = z.infer<typeof pwResetRequestSchema>;
export type PwResetConfirmData = z.infer<typeof pwResetConfirmSchema>;
